<template>
	<div>
		<Layout @cta="$refs.sellForm.open()" :footer="false" class="bg-light" :navTransparent="true">
			<div class="banner-suarez">
				<div class="suarez"></div>
				<div class="bg">
					<div class="content"></div>
				</div>
			</div>

			<div class="content p-3">
				<div class="container">
					<div class="row">
						<div class="col">
							<PositionCard ref="positionCard" />

							<!-- <FeaturedProducts /> -->
						</div>
					</div>
					<div class="row">
						<div class="col">
							<div class="sell-card " @click="$refs.sellForm.open()" v-ripple>
								<h2>Registrar venta</h2>
								<p>¡Registrá tus ventas y sumá puntos!</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- <template slot="footer">
				<router-link tag="a" to="/sell" class="btn btn-primary btn-add" v-ripple>
					<i class="icon icon-plus invert"></i>
				</router-link>
			</template> -->
		</Layout>

		<SellFormModal ref="sellForm" @created="sellCreated" />
	</div>
</template>
<script>
import Layout from '@/components/layout/Layout'
import PositionCard from '@/components/PositionCard'
import FeaturedProducts from '@/components/FeaturedProducts'
import SellFormModal from './SellFormModal'

export default {
	name: 'Home',
	components: {
		Layout,
		PositionCard,
		FeaturedProducts,
		SellFormModal,
	},
	methods: {
		sellCreated() {
			this.$bvModal.hide('modalSell')
			this.$refs.positionCard.load()
		},
	},
}
</script>

<style scoped>
.banner-suarez {
	width: 100vw;
	height: 64vh;
	position: relative;
	display: inline-block;
	/* background-color: #a50034; */
	/* border-radius: 0px 0px 24px 24px; */
	background-image: url('~@/assets/img/banner-suarez-bg.png');
	background-size: cover;
	background-position: center center;
	overflow: hidden;
}
.banner-suarez .bg {
	width: 100vw;
	height: 60vh;
	margin-top: 40vh;
	background-color: #fff;
	position: relative;
}
.banner-suarez .bg:before {
	content: '';
	position: absolute;
	top: -50px;
	left: 0px;
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 0 0 50px 100vw;
	border-color: transparent transparent #ffffff transparent;
}

.banner-suarez .suarez {
	width: 100%;
	height: 70vh;
	position: absolute;
	top: 40px;
	left: 0;
	background-image: url('~@/assets/img/banner-suarez.png');
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
}
.banner-suarez .content {
	width: 100%;
	height: 26vh;
	max-width: 400px;
	margin: auto;
	margin-top: -18px;
	padding: 0px 40px;
	background-image: url('~@/assets/img/banner-suarez-content.png');
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
}

h1 {
	font-size: 22pt;
}

.sell-card {
	border-radius: 12px;
	width: 100%;
	max-width: 480px;
	margin: 16px auto;
	color: #fff;
	background-color: #a50034;
	padding: 24px 16px;
}
.sell-card h2 {
	font-size: 16pt;
	font-weight: 600;
}
.sell-card p {
	margin: 0px;
}
</style>
